import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import { ReactComponent as SortIcon} from '../../../assets/images/CommonComponent/arrow-down.svg';
import styled from "@emotion/styled";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { ANALYTICAL_REPORT, EDIT_ACTIVITY, VIEW_ACTIVITY, VIEW_INTERESTED_GUEST_LIST_ACTIVITY } from "../../../Router/RoutesURL";
import { CircularProgress, TablePagination, tablePaginationClasses } from "@mui/material";
import { ReactComponent as arrowDownIcon} from '../../../assets/images/CommonComponent/downArrow.svg'
import moment from "moment";
import { DATE, DATETIME, TINYINT } from "../../../Config/Constant";
import { getComparator, getPermissionByAppName, options, stableSort, validateDate } from "../../../utils/Helper";
import Select from "react-select";
import { createNotification } from "../../../Config/NotificationToast";
import { useDispatch } from "react-redux";
import { updateIsActiveStatus } from "../../../redux/actions/MasterDataAction/ProgramAction/programActions";
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import './ViewChildActivityTable.scss'
import { Modal } from "react-bootstrap";
import { deleteMasterDataModule } from "../../../redux/actions/MasterDataAction/RecipeCollection/RecipeCollectionAction";

const TableRowStyled = styled(TableRow)`
//   &:nth-of-type(odd) td {
//     border: none;
//     padding-bottom: 0;
//   },

//   &:nth-of-type(odd) td:first-of-type {
//     border-left: 2px solid #DDDDDD;
//   },

//   &:nth-of-type(odd) td:last-child {
//     border-right: 2px solid #DDDDDD;
//   },

//   &:nth-of-type(even) td {
//     border-top: 2.5px solid #DDDDDD;
//     background-color: #F5F5F5;
//   },

//   &:nth-of-type(even) td:first-of-type {
//     border-left: 2px solid #DDDDDD;
//   },

//   &:nth-of-type(even) td:last-child {
//     border-right: 2px solid #DDDDDD;
//   },
`;

const TableCellStyled = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: '500 !important',
    zIndex: 0,
    color: "#AAAAAA",
    padding: '5px 0 5px 15px',
    wordBreak: "break-word",
    fontSize: "14px",
    textTransform: 'uppercase',
    borderTop: "1px solid #DDDDDD",
  },
  


  [`&.${tableCellClasses.body}`]: {
    fontSize: "12px",
    padding: '6px 6px 6px 15px',
    wordBreak: "break-word",
    fontSize: "14px",
    height: 'fit-content'
  },

  [`&.${tableCellClasses.body}:first-of-type`]: {
    textTransform: 'capitalize',
    // borderLeft: '0.5px solid #74613C',
    padding: '6px 6px 6px 15px',
  },
}));

const TablePaginationStyled = styled(TablePagination)(({ theme }) => ({
  fontSize: '13px',

  [`& .${tablePaginationClasses.select}`]: {
    padding: '4px 8px',
    // borderRadius: '8px',
    // backgroundColor: '#F5F3EC',
    border: '1px solid #DDDDDD'
  },

  [`& .${tablePaginationClasses.select}, & .${tablePaginationClasses.select}:focus`]: {
    borderRadius: '5px',
    backgroundColor: 'white',
    border: '1px solid #DDDDDD'
  },

  [`& .${tablePaginationClasses.selectLabel}, & .${tablePaginationClasses.displayedRows}`]: {
    margin: '0',
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    top: '12px',
    right: '7px',
    width: '9px'
  },


  [`& .${tablePaginationClasses.actions} button`]: {
    backgroundColor: 'white',
    marginRight: '5px',
    padding: '3px 5px',
    border: '1px solid #DDDDDD',
    borderRadius: '5px'

  },

  [`& .${tablePaginationClasses.actions} svg`]: {
    width: '20px'
  },

}));

const generateSubOptionslabel = (item, level=1)=>{
    let s = item?.[`nested_data_level${level}`]?.sub_category;
    if(!s)
      return ''
    return ` \n- ${s} ${generateSubOptionslabel(item, level+1)}`
  }

const ViewChildActivityTable = ({
  loading,
  data,
  columns,
  checkbox = true,
  pagination = true,
  filter,

  //props are required if pagination is true
  totalCount,
  totalPages,
  start,
  end,
  currentPage,
  rowsPerPage,
  getTableData
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [selected, setSelected] = useState([]);
  const [activityData, setActivityData] = useState(data || []);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [id, setId] = useState();
  const dispatch = useDispatch();
  let permission=getPermissionByAppName("Activity Master")
  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
};

  const handleChangeOption = (e, id) => {
    if (permission === "write") {
        setActivityData(prev=> {
          let d = [...prev]
          for(let i=0; i<d.length; i++){
            if (d[i].id === id) {
              let active = d[i].is_active
              d[i].is_active = active ? 0 : 1;
            }
          }
          return d;
        })
        const sendRequest = {
            "feature_type": "daily_activity",
            "id": id,
            "status": e.value === "Active" ? 1 : 0
        };
        dispatch(updateIsActiveStatus(sendRequest));
    } else {
        createNotification('warning', "Access Restricted");
    }
  }

  const handleViewGuestList = (activityId, activityTitle) => {
      navigate(VIEW_INTERESTED_GUEST_LIST_ACTIVITY, { state: { selectedActivityId: activityId, activityTitle } })
  };
  
  const handleNavigateViewActivity = (activityId, activityTitle, status) => {
          navigate(VIEW_ACTIVITY, { state: { activityId, activityTitle, status, permission } })
      };
  
  const handleNavigate = (activityId,) => {
      if (permission === "write") {
          navigate(EDIT_ACTIVITY, { state: { activityId } })
      } else {
          createNotification('warning', "Access Restricted");
      }
  };
  

  const handleDelete = (id) => {
      if (permission === "write") {
          setId(id)
          setShowDeleteModal(true);
      } else {
          createNotification('warning', "Access Restricted");
      }
  };

  const closeDeleteModal = () => {
      const sendRequest = {
          "feature_type": "daily_activity",
          "ids": id,
          onSuccessCallback: ()=>{
            if(!(activityData.find(item=> item.id ===id)?.repeat_ref_id))
              navigate(-1)
            else
              setActivityData(prev=>{
                let d=[...prev]
                return d.filter(item=> item.id !=id)
              })
          }
      };
      dispatch(deleteMasterDataModule(sendRequest));
      setShowDeleteModal(false);
      }

  const handleChangePage = (e, newPage) => {
    window.scrollTo(0, 0)
      searchParams.delete("page")
      navigate({
        pathname: `${ANALYTICAL_REPORT}`,
        search: `?${createSearchParams([...searchParams.entries(), ["page", newPage]])}`,
      }, {replace: true})
  };

  const handleChangeRowsPerPage = (e) => {
    window.scrollTo(0, 0)
    let value=parseInt(e.target.value, 10);
    if (rowsPerPage !== value) {
      searchParams.delete("pageLimit")
      searchParams.delete("page")
      navigate({
        pathname: `${ANALYTICAL_REPORT}`,
        search: `?${createSearchParams([...searchParams.entries(), ["pageLimit", value]])}`,
      })
    }
  };

  const isSelected = (id, flatId) => selected.some(item => item.subscriberId === id && item.flatId === flatId);


  useEffect(()=>{      
    setSelected([])
  }, [searchParams])

  useEffect(()=>{
    setOrder(filter?.order)
    setOrderBy(filter?.orderBy)
  }, [filter])

  useEffect(()=>{
    setActivityData(data)
  }, [data])

  return (
    <Box
      sx={{ width: "100%", fontSize: "13px" }}
      className="child-activity-table-component h-100 "
    >
      <TableContainer
        sx={{minHeight: '400px', maxHeight: '400px'}}
        className="bg-white"
      >
        {
          loading ? 
          <div className="text-center border-top"><CircularProgress size={35} className='mt-5' sx={{'color': '#74613C'}}/></div>
        //   !data?.length ?
        //   <div className="text-center border-top pt-4 text-muted" style={{fontSize: '14px'}}>No Records</div>
          :
          <Table stickyHeader className="h-100"   aria-label="sticky table">
            <TableHead className="position-sticky  top-0" sx={{zIndex: 5}}>
              {/* {renderHeaders(columns)} */}
              <TableRow>
              {columns?.map((item, ind) => {
                return (
                  <TableCellStyled
                    size="small"
                    key={ind}
                    className="bg-white"
                    align={"left"}
                    sx={{
                      minWidth: item.width,
                      maxWidth: item.width,
                      verticalAlign: 'top',
                      paddingLeft: '10px',
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === item.id}
                      direction={orderBy === item.id ? order : 'asc'}
                      onClick={createSortHandler(item.id)}
                      hideSortIcon={!item.sorting}
                      disabled={!item.sorting}
                      >
                      {item.label}
                      {orderBy === item.id ? (
                          <Box component="span" sx={visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                      ) : null}
                  </TableSortLabel>
                  </TableCellStyled>
                )
              })}
            </TableRow>
            </TableHead>
            <TableBody>
              {
                  loading ?
                  <TableRow >
                    <TableCellStyled sx={{border: 'none'}} colSpan={columns?.length+1}><div className='text-center mb-3'><CircularProgress size={35} sx={{'color': '#74613C'}}/></div></TableCellStyled>
                  </TableRow>
                  :
                  <>
                    {!activityData?.length &&
                      <TableRowStyled
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <TableCell className="text-muted text-center" colSpan={columns.length}>No Records</TableCell>
                      </TableRowStyled>
                    }
                    {!!activityData?.length && stableSort(activityData, getComparator(order, orderBy))?.map((row, rowIndex) => {
                        const isRowSelected = isSelected(row?.subscriberId, row.flatId);

                        return (
                          <React.Fragment 
                            key={`${rowIndex}`}
                          >
                            <TableRowStyled
                              role="checkbox"
                              aria-checked={isRowSelected}
                              tabIndex={-1}
                              selected={isRowSelected}
                            >
                              <TableCellStyled size="small" align="left">
                                  {row.title || '-'}
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                  {row.no_of_capacity || '-'}
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                {
                                  row.booked_user > 0
                                  ?
                                  <> {row.booked_user} <span className="viewLink" onClick={() => { handleViewGuestList(row.id, row.title) }}> (View Guest List)</span></>
                                  :
                                  0
                                }
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                  {row.venue || '-'}
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                  {row.activity_datetime ? row.activity_datetime :  '-'}
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                  {row.activity_time ? row.activity_time :  '-'}
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                <Select
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  onChange={(e) => { handleChangeOption(e, row.id, row.is_active) }}
                                  value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                  options={options}
                                  isSearchable={false}
                                  menuPlacement="auto"
                                  menuPosition="absolute"   
                                  is
                                  menuPortalTarget={null}
                                  theme={(theme) => ({
                                      ...theme,
                                      isFocused: "#74613C",
                                      colors: {
                                          ...theme.colors,
                                          primary25: '#F5F5F5',
                                          primary: '#f6f4f0',

                                      },
                                  })}
                                  getOptionLabel={(row) => (
                                      <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"} >
                                          {row.label}
                                      </span>
                                          {row.is_active === 1 && (
                                              <div

                                              ></div>
                                          )}
                                      </>
                                  )}
                              />
                              </TableCellStyled>
                              <TableCellStyled size="small" align="left">
                                <div className="d-flex flex-row actions">
                                  <span
                                      className={!(row.is_active == 1) || row.isParent ? 'mr-3 disabled' : "mr-3"}
                                      onClick={!(row.is_active == 1) || row.isParent ? undefined : () => { handleNavigateViewActivity(row.id, row.title, row.is_active) }}>
                                        <i className="fas fa-eye mr-1"></i> 
                                        View
                                  </span>
                                  {
                                      getPermissionByAppName("Activity Master") === "write" &&
                                      <>
                                          <span
                                              className={!(row.is_active == 1) ? 'mr-3 disabled' : "mr-3"}
                                              onClick={!(row.is_active == 1) ? undefined: () => { handleNavigate(row.id) }}><i className="fa fa-pen mr-1"></i> Edit
                                          </span>

                                          <span className=" Delete p-0 mr-3" onClick={() => { handleDelete(row.id) }}>
                                            <img src={Delete} className="mr-1 mb-1" alt="Avatar" width="14px" height="16px" /> 
                                            Delete
                                          </span>
                                      </>
                                  }
                              </div>
                              </TableCellStyled>
                            </TableRowStyled>
                          </React.Fragment>
                        );
                      })}
                  </>
                }
            </TableBody>
          </Table>
        }
      </TableContainer>
      {
        showDeleteModal &&
        <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        closeDeleteModal={closeDeleteModal}
        />
      }

      {/* {!!pagination && !!data?.length && (
        <div className="mx-4">
          <TablePaginationStyled
            disabled={loading}
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={totalCount || 0}
            rowsPerPage={rowsPerPage || 10}
            page={currentPage || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            SelectProps={{
              IconComponent: arrowDownIcon,
            }}
        />
        </div>
      )} */}
    </Box>
  );
};

ViewChildActivityTable.propTypes = {
  columns: PropTypes.array.isRequired,
  defaultSortField: PropTypes.string,
  rowsPerPageOptions: PropTypes.array,
};

export default ViewChildActivityTable;


const DeleteModal = ({showDeleteModal, setShowDeleteModal, closeDeleteModal})=>{
  return (
    <Modal centered className="TeamMember-modal-warning br-8" show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }}>
      <Modal.Header>
          <div className="modalText pb-4">Are you sure?</div>
      </Modal.Header>
      <Modal.Body>
          <div className="">
              <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc">You want to delete this record?</label>
          </div>
      </Modal.Body>
      <Modal.Footer>
          <button type="button" className="btn btn-success greenButton mr-3" onClick={()=>{setShowDeleteModal(false)}}>
              Cancel</button>
          <button type="button" className="btn btn-danger redButton " onClick={closeDeleteModal}>
              Delete</button>
      </Modal.Footer>
  </Modal>
  )
}